import React, { useState } from 'react'
import { useStyles } from './FlyOutArnDetailsWrapper.styles'
import { BoxV2, ExternalLink } from '@labrav/react-components'
import { flyoutCFTDescription } from '../../../common/utils/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons'
import { HelpDrawer } from '@labrav/common'
import ArnImage from '../../../common/images/ArnImage.png'
import WhatAreYouDoingHereData from '../../../mocks/whatAreYouDoingHere.json'
import { Typography } from '@mui/material'
import clsx from 'clsx'
import { VideoModal } from '../../../common/components/ProductVideoAction/VideoModal'

export type FlyOutCloudSettingsProps = {
  children: JSX.Element
}
export const FlyOutArnDetailsWrapper: React.FC<FlyOutCloudSettingsProps> = ({
  children,
}) => {
  const { classes } = useStyles()

  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const handleThumnailClick = () => {
    setIsVideoOpen(true)
  }

  return (
    <BoxV2
      heading={'Platform role ARN'}
      subHeading={flyoutCFTDescription}
      headingIcon="STEP 02"
      secondaryActions={
        <HelpDrawer
          sectionName="flyOutProductionEnvironmentARN"
          headerTitle="Help"
        />
      }
    >
      <>
        <Typography className={clsx(classes.sectionText, classes.noteText)}>
          <span className={classes.boldText}>Note: </span>Please ensure that
          your stack name only permits lower case with -allowed. No spaces
          should be there in between.
        </Typography>
        <div className={classes.content}>
          {children}
          <div className={classes.verticalDivider}></div>
          <div
            className={classes.videoWrapper}
            data-testid={'vertical-divider'}
          >
            <div
              className={classes.videoContainer}
              data-testid="video-cloud-settings-details-arn"
            >
              <div className={classes.thumbnailWrapper}>
                <img
                  className={classes.thumbnailImages}
                  src={ArnImage}
                  title="Labra FlyOut"
                  alt={'what-are-you-doing-here'}
                  onClick={handleThumnailClick}
                />
                <FontAwesomeIcon
                  icon={faCirclePlay}
                  className={classes.playButton}
                  onClick={handleThumnailClick}
                  style={{
                    height: '50px',
                  }}
                />
              </div>
            </div>
            <div data-testid="video-link-cloud-settings-arn">
              <ExternalLink
                href={WhatAreYouDoingHereData.cloudSettingArnDetails.video}
              >
                {WhatAreYouDoingHereData.cloudSettingArnDetails.linkText}
              </ExternalLink>
            </div>
          </div>
        </div>
        <VideoModal
          actionTitle="Platform role ARN"
          actionLable=""
          isVideoModalOpen={isVideoOpen}
          setIsVideoModalOpen={setIsVideoOpen}
          videoLink={WhatAreYouDoingHereData.cloudSettingArnDetails.video}
        />
      </>
    </BoxV2>
  )
}
